var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aecbfa;}.cls-2{fill:#4285f4;}.cls-3{fill:none;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_RuntimeConfig_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "cls-1",
    points: "2 8 8 8 8 2 2 2 2 8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7,
    y: 4,
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "cls-1",
    points: "15 13 3 13 3 10 15 10 15 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4-Copy-2",
    className: "cls-1",
    points: "13 20 3 20 3 16 13 16 13 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    className: "cls-2",
    points: "5 8 8 8 8 2 5 2 5 8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11-2",
    "data-name": "Fill-11",
    className: "cls-1",
    points: "16 22 22 22 22 16 16 16 16 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15-2",
    "data-name": "Fill-15",
    className: "cls-2",
    points: "19 22 22 22 22 16 19 16 19 22"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18,
    y: 4,
    width: 2,
    height: 12
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.c5ef7bff7c718e3d751078577470fd44.svg";
export { ForwardRef as ReactComponent };